import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ userRole, onStartNewChat }) => {
  return (
    <div className="h-full flex items-center justify-center p-6 bg-background">
      <div className="max-w-md text-center">
        <div className="w-20 h-20 md:w-24 md:h-24 mx-auto bg-primary/10 rounded-full flex items-center justify-center mb-6">
          <Icon name="MessageSquare" size={48} color="var(--color-primary)" />
        </div>

        <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
          {userRole === 'student' ? 'Start a Conversation' : 'No Active Chats'}
        </h2>

        <p className="text-sm md:text-base text-muted-foreground mb-6">
          {userRole === 'student' ?'Select an institute from your conversations or visit a virtual booth to start chatting with representatives.' :'When students reach out to you, their conversations will appear here. You can respond in real-time and manage your leads effectively.'
          }
        </p>

        {userRole === 'student' && (
          <Button
            variant="default"
            iconName="Building2"
            iconPosition="left"
            onClick={onStartNewChat}
          >
            Explore Institutes
          </Button>
        )}

        <div className="mt-8 p-4 bg-muted rounded-lg">
          <div className="flex items-start gap-3 text-left">
            <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Chat Features
              </p>
              <ul className="text-xs text-muted-foreground space-y-1">
                <li>• Real-time messaging with instant delivery</li>
                <li>• Share PDF documents and brochures</li>
                <li>• Escalate to video counseling sessions</li>
                <li>• Chat history preserved for reference</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;